// Existing write/submission choices. No type-specific market policy has been approved.
export const listingChoices = {
 propertyType:'apartment,studio,villa,twin_villa,townhouse,penthouse,land,farm,office,shop,retail,warehouse,industrial,hotel_apartment,building,compound,commercial_complex,mixed_use_property,staff_accommodation,labor_camp,clinic_medical_space,restaurant_cafe_space,showroom,school_nursery_property,tourism_hospitality_property,construction_project,off_plan_unit,investment_opportunity'.split(','),
 purpose:'sale,rent,off_plan,short_term_rent,construction_land,commercial_use,investment'.split(','),
 listingType:'sale,rent,rental,off_plan,short_term_rent,construction_land,commercial_use,investment'.split(','),
 rentPeriod:'monthly,yearly,weekly,daily,nightly'.split(','),
 furnished:'unknown,furnished,semi_furnished,unfurnished'.split(','),
 completionStatus:'ready,completed,under_construction,off_plan'.split(',')
};
export const listingSubmissionFields = ['titleEn','titleAr','propertyType','purpose','priceOMR','areaSqm'];
export const listingNumericRules = {
 priceOMR:[0,Number.MAX_SAFE_INTEGER/1000],deposit:[0,Number.MAX_SAFE_INTEGER/1000],serviceCharge:[0,Number.MAX_SAFE_INTEGER/1000],maintenanceFee:[0,Number.MAX_SAFE_INTEGER/1000],
 areaSqm:[0,1000000000],bedrooms:[0,1000000,true],bathrooms:[0,1000000,true],parkingSpaces:[0,1000000,true],floorNumber:[-100,1000,true],totalFloors:[0,1000000,true],builtYear:[0,9999,true]
};
export const factsGroups = [
 {key:'identity',fields:['propertyType','purpose','listingType']},
 {key:'costs',fields:['priceOMR','rentPeriod','deposit','serviceCharge','maintenanceFee']},
 {key:'space',fields:['areaSqm','bedrooms','bathrooms','parkingSpaces','furnished','floorNumber','totalFloors','builtYear','completionStatus']},
 {key:'place',fields:['governorateId','wilayatId','neighborhoodId','address','longitude','latitude']},
 {key:'words',fields:['titleEn','titleAr','descriptionEn','descriptionAr']}
];
export const guidedFields = factsGroups.flatMap(group=>group.fields);
export const factsEditableFields = [...guidedFields.filter(key=>!['longitude','latitude'].includes(key)),'location','governorate','wilayat','neighborhood'];
export const normalizeListingNumber = value => String(value).trim().replace(/[٠-٩۰-۹]/g,c=>String('٠١٢٣٤٥٦٧٨٩'.includes(c)?'٠١٢٣٤٥٦٧٨٩'.indexOf(c):'۰۱۲۳۴۵۶۷۸۹'.indexOf(c))).replace(/٫/g,'.');
export function factsForm(record={}) {
 const source={...record,...record.workingRevision};
 return Object.fromEntries(guidedFields.map(key=>[key,key==='longitude'?String(source.location?.coordinates?.[0]??''):key==='latitude'?String(source.location?.coordinates?.[1]??''):String(source[key]??'')]));
}
export function factsPatch(form,base={},isNew=false) {
 const original=factsForm(base),patch={},errors={};
 for(const key of guidedFields.filter(key=>!['longitude','latitude'].includes(key))){
  if(!isNew&&form[key]===original[key])continue;
  const raw=form[key]??'';
  if(listingNumericRules[key]){
   if(raw===''){if(base[key]!==undefined)errors[key]='number';continue;}
   const text=normalizeListingNumber(raw),value=Number(text),[min,max,integer]=listingNumericRules[key];
   if(!/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(text)||!Number.isFinite(value)||value<min||value>max||(integer&&!Number.isInteger(value)))errors[key]='number';else patch[key]=value;
  } else if(isNew&&raw==='')continue;else patch[key]=raw;
 }
 if(isNew||form.longitude!==original.longitude||form.latitude!==original.latitude){
  if(form.longitude===''&&form.latitude==='') {if(base.location?.coordinates)patch.location={};}
  else {
   const coordinates=[form.longitude,form.latitude].map(normalizeListingNumber),numbers=coordinates.map(Number);
   if(coordinates.some((v,i)=>!/^[-+]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(v)||!Number.isFinite(numbers[i])||Math.abs(numbers[i])>(i===0?180:90)))errors.location='coordinates';
   else patch.location={type:'Point',coordinates:numbers};
  }
 }
 return {patch,errors};
}
export const missingFacts = form => listingSubmissionFields.filter(key=>{
 if(listingChoices[key])return !listingChoices[key].includes(form[key]);
 if(listingNumericRules[key]){const text=normalizeListingNumber(form[key]??''),value=Number(text);return !/^[+]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(text)||!Number.isFinite(value)||value<=0||value>listingNumericRules[key][1];}
 return !String(form[key]||'').trim()||String(form[key]).length>160;
});
export const factsDirty = (form,base={}) => JSON.stringify(form)!==JSON.stringify(factsForm(base));
// Overlay only edits made against the opened baseline; never replace unrelated newer facts.
export function reapplyFacts(form,base,latest){
 const original=factsForm(base),next=factsForm(latest);
 for(const key of guidedFields)if(form[key]!==original[key])next[key]=form[key];
 return next;
}
export const hierarchyClears = key => key==='governorateId'?['wilayatId','neighborhoodId']:key==='wilayatId'?['neighborhoodId']:[];
